export default {
  getCategories: {
    uri: 'shops/%shop%/categories',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopProductList: {
    uri: 'shops/%shop%/products',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopsByCategory: {
    uri: 'categories/%category%/shops',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopProductDetails: {
    uri: 'shops/%shop%/products/%product%',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopProductImages: {
    uri: 'shops/%shop%/products/%product%/images',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopList: {
    uri: 'shops',
    method: 'GET',
    loading: true,
    subdomain: true
  },
  getShopDetails: {
    uri: 'shops/%shop%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getActiveWaitingList: {
    uri: 'shops/%shop%/lines',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getShopCarriers: {
    uri: 'shops/%shop%/carriers',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getShopCarrier: {
    uri: 'shops/%shop%/carriers/%carrier%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getCoupons: {
    uri: 'shops/%shop%/coupons',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getShopCoupon: {
    uri: 'shops/%shop%/coupons/%coupon%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/shop.js